import { listPatients } from './listPatients'
import { matchingProfessional } from './matchingProfessional'
import { updatePatientInfo } from './updatePatientInfo'

export const PersonsService = {
  listPatients,
  matchingProfessional,
  updatePatientInfo,
}